import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useFollowedTeams() {
  const { user } = useAuth();
  return user?.teams || [];
}

export function TeamFollowButton({ sport, slug, team, size = "sm", onChange }) {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const key = `${sport}/${slug}`;
  const following = (user?.teams || []).includes(key);
  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post("/teams/watch/toggle", { sport, slug });
      setUser((u) => ({ ...u, teams: data.teams }));
      toast.success(data.following ? `Following ${team} — their games, picks and standings moves now lead your dashboard` : `Unfollowed ${team}`);
      onChange?.(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  if (size === "icon") {
    return (
      <button data-testid="team-follow-btn" onClick={toggle} disabled={busy} title={following ? "Unfollow team" : "Follow team"} className={`rounded-full p-1 transition-colors ${following ? "text-amber-300" : "text-slate-600 hover:text-amber-300"}`}>
        <Star size={13} className={following ? "fill-amber-300" : ""} />
      </button>
    );
  }
  return (
    <button data-testid="team-follow-btn" onClick={toggle} disabled={busy}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 disabled:opacity-60 ${following ? "border-amber-400/60 bg-amber-500/15 text-amber-200" : "border-[#26334D] text-slate-300 hover:border-amber-400/60 hover:text-amber-200"}`}>
      <Star size={13} className={following ? "fill-amber-300 text-amber-300" : ""} /> {following ? "Following" : "Follow team"}
    </button>
  );
}
